import { render } from "./CreateBook.vue?vue&type=template&id=0b1637c6&scoped=true&ts=true"
import script from "./CreateBook.vue?vue&type=script&lang=ts"
export * from "./CreateBook.vue?vue&type=script&lang=ts"

import "./CreateBook.vue?vue&type=style&index=0&id=0b1637c6&scoped=true&lang=scss"
import "./CreateBook.vue?vue&type=style&index=1&id=0b1637c6&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1637c6"]])

export default __exports__